<template>
  <div id="container">
    <a href="/">
      <img src="../assets/white-logo.png" id="logo" />
    </a>
    <h1>Creators Hub</h1>
  </div>
</template>

<style scoped>
#logo {
  width: 210px;
  filter: drop-shadow(1px 1px 3px rgba(1, 1, 1, 0.2));
  transition: transform 0.3s ease;
}
#logo:hover {
  transform: scale(1.03);
}
h1 {
  font-size: 1.6em;
  margin-top: 0.3em;
  color: white;
  filter: drop-shadow(1px 1px 3px rgba(1, 1, 1, 0.2));
  letter-spacing: 0.04em;
  font-weight: 600;
  text-align: center;
}
</style>
